export const SSL = 'SSL'